export var GeoPagesRoutes;
(function (GeoPagesRoutes) {
    GeoPagesRoutes["CITIES"] = "locations";
    GeoPagesRoutes["REGIONS"] = ":region";
    GeoPagesRoutes["CITY"] = ":region/:city";
})(GeoPagesRoutes || (GeoPagesRoutes = {}));
